import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { FiCheck, FiArrowRight } from "react-icons/fi";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import ServiceCard from "../components/ServiceCard";
import ServiceIcon from "../components/ServiceIcon";
import CTA from "../components/CTA";
import services, { getServiceBySlug } from "../data/services";

const Service = () => {
  const { slug } = useParams();
  const svc = getServiceBySlug(slug);

  if (!svc) return <Navigate to="/services" replace />;

  const idx = services.findIndex((s) => s.slug === slug);
  const others = services.filter((s) => s.slug !== slug).slice(0, 3);

  return (
    <Layout>
      <SEO title={svc.title} description={svc.short} />

      <section className="service-hero">
        <div className="container">
          <div className="crumbs">
            <Link to="/">Home</Link><span className="sep">/</span>
            <Link to="/services">Services</Link><span className="sep">/</span>
            {svc.title}
          </div>
          <span className="eyebrow eyebrow--light">{String(idx + 1).padStart(2, "0")} / Service</span>
          <h1>{svc.title}</h1>
          <p className="lead">{svc.summary}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="service-body">
            <div className="body-copy">
              {svc.paragraphs.map((p, i) => <p key={i}>{p}</p>)}

              <div style={{ marginTop: "2.5rem" }}>
                <Link to="/contact" className="btn btn--dark">
                  Discuss this service <FiArrowRight />
                </Link>
              </div>
            </div>

            <aside className="sidebar">
              <div className="card">
                <div style={{ display: "flex", alignItems: "center", gap: ".75rem", marginBottom: "1.25rem" }}>
                  <span style={{
                    width: 44, height: 44, borderRadius: 12,
                    background: "#0a1628", color: "#d8bb83",
                    display: "grid", placeItems: "center", fontSize: "1.2rem"
                  }}>
                    <ServiceIcon name={svc.icon} />
                  </span>
                  <h4 style={{ margin: 0 }}>What's included</h4>
                </div>
                <ul className="feature-list">
                  {svc.bullets.map((b, i) => (
                    <li key={i}>
                      <span className="check"><FiCheck /></span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>

          <div className="other-services mt-3">
            <div className="section-title section-title--left">
              <span className="eyebrow">Also relevant</span>
              <h2 style={{ fontSize: "1.8rem" }}>Other services you may want to combine.</h2>
            </div>
            <div className="grid grid--3">
              {others.map((s, i) => (
                <ServiceCard key={s.slug} service={s} index={services.findIndex(x => x.slug === s.slug)} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTA />
    </Layout>
  );
};

export default Service;
